/*
==========================================
Custom JS for FAQ and User guide page
==========================================
*/

const smoothScroll = (hash) =>{
  const targetElement = document.querySelector(hash);
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const target = rect + offset;
  window.scrollTo({
    top: target,
    behavior: 'smooth',
  });

  // FAQカテゴリーの場合、初めのFAQ項目を開く
  if(targetElement.getAttribute('data-faq_category') === "true"){
    const faq_item = targetElement.nextElementSibling.querySelector('summary');
    if(targetElement.nextElementSibling.hasAttribute('open') === false && faq_item){
      faq_item.click()
    }
  }
}

window.addEventListener("DOMContentLoaded",() => {
  // 初期表示時
  const firstViewHash = decodeURI(location.hash);
  if(firstViewHash){
    smoothScroll(firstViewHash);
  }

  // アンカーリンク押下時
  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++){
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      smoothScroll(href);
    });
  }
});